export default function IconArrow() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
            <path
                d="M23 27C25.2091 27 27 25.2091 27 23L27 4C27 1.79086 25.2091 2.20385e-06 23 2.01072e-06L4 3.49691e-07C1.79086 1.56562e-07 2.01074e-06 1.79086 2.01074e-06 4L3.49706e-07 23C3.49706e-07 25.2091 1.79086 27 4 27L23 27ZM6.09375 16.21L13.5693 8.88672L20.9033 16.2197L19.0176 18.1055L13.5498 12.6387L7.95996 18.1152L6.09375 16.21Z"
                fill="#CFD0D2"
            />
        </svg>
    );
}
